import { Directive, ElementRef, forwardRef, Input, Renderer2, inject } from '@angular/core';
import { FormLayout } from './form-layout';
import { FormColumnsDirective } from './form-columns.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'form-row',
  host: {
    class: 'form-row bsg-form-group',
  },
  providers: [{ provide: FormLayout, useExisting: forwardRef(() => FormRowDirective) }],
})
export class FormRowDirective extends FormColumnsDirective {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  public groupClasses = '';

  @Input() public set removeClass(value: string) {
    this.renderer.removeClass(this.elementRef.nativeElement, value);
  }
}
